import { styled } from '@mui/material'

// The backend masks account numbers with asterisks, which Inter draws high on the line next to
// digits -- and, through its contextual alternates, at two different heights within one run.
// Each masked run is drawn with the contextual alternates off, so every asterisk takes the same
// shape, and nudged down so it sits level with the middle of the digits. The text is unchanged.
export const MaskedNumber = ({ value }: { value?: string | null }) => {
  const parts = (value ?? '').split(/(\*+)/).filter(Boolean)

  return (
    <>
      {parts.map((part, index) => (part.startsWith('*') ? <Mask key={index}>{part}</Mask> : part))}
    </>
  )
}

// Measured in Inter: an asterisk's centre sits 0.52em above the baseline, the digits' 0.36em.
const Mask = styled('span')({
  fontFeatureSettings: '"calt" 0',
  position: 'relative',
  top: '0.16em',
})
